/**
 * Orígenes por etiqueta Kommo — Sales_Origin_Tags vía analytics-api.
 * @module-isolated analytics-config-origins
 * @depends analytics-api.js, firebase-auth.js
 * @consumers ConfigPage / OriginTagsPanel
 */
import { fetchOriginTags, saveOriginTags } from '../../../services/analytics-api.js';
import { getIdToken } from '../../../services/firebase-auth.js';

export async function loadOriginTags(opts) {
  const token = await getIdToken(false);
  return fetchOriginTags(token, opts);
}

/**
 * @param {Array<object>} tags
 * @param {{ turnstileToken?: string }} opts
 */
export async function persistOriginTags(tags, opts) {
  const token = await getIdToken(false);
  return saveOriginTags(tags, token, opts);
}
